<template>
  <b-card no-body class="shadow h-100 flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="Version Control" widget-name="clone">

      </window-header>
    </div>

    <div class="flex-full-height-3  pr-3 pl-3">
      <div class="flex-container w-100">
        <b-form>
          <b-row>
            <b-col cols='12'>
              <b-form-group label="Model name:">
                <b-form-input @keyup.prevent.native="modelNameState=null" :state="modelNameState" v-model="modelName" placeholder="Enter model name"></b-form-input>
                <b-form-invalid-feedback>
                  Model name is required
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col >
              <span class="batch-title">Projects:</span>
              <div class='batch-container'>
                <b-row v-for="batch in batch_zones" :key="'batch'+batch.value">
                  <b-col>
                    <b-form-group class='batch-project'>
                      <b-form-checkbox v-model="batch.selected">{{batch.text}}</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <!-- <div>
            <small>AOI: {{aoi === null ? 'Whole model' : 'Custom area'}}</small>
          </div> -->
        </b-form>

      </div>
    </div>

    <div class="row p-2">
      <div class="col"></div>
      <b-button class="mr-3" v-b-tooltip.hover  variant="dark" @click="saveRequest">
        <icon name="check" scale=".8" ></icon>
        Request Clone
      </b-button>
    </div>
    <window-footer></window-footer>
  </b-card>
</template>

<script>
  import WindowHeader from './common/WindowHeader'
  import WindowFooter from './common/WindowFooter'
  import ScopeInput from './map/designotron/ScopeInput'
  import ScopeManager from './map/designotron/ScopeManager'

  export default {
    name: 'HistoryTool',
    components: {ScopeManager, ScopeInput, WindowHeader, WindowFooter},
    data () {
      return {
        modelName: null,
        modelNameState: null,
        aoi: null,
        batch_zones: [],
        packed_zones: []
      }
    },
    mounted () {
      this.loadBatchZones()
    },
    methods: {
      loadBatchZones () {
        this.batch_zones = []
        this.$http.get('/api/layers/get-batch-zones', {
          params: {
            workpack_id: this.$store.getters['project/currentProject'].workpack.id
          }
        }).then(res => {
              res.body.forEach(t =>
                this.batch_zones.push({text: t.batch_name, value: t.gid})
              )
              if (this.batch_zones.length) {
                this.batch_zones.sort(function(a, b){
                    if(a.text < b.text) { return -1; }
                    if(a.text > b.text) { return 1; }
                    return 0;
                })
              }
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load batch zones',
              type: 'error'
            })
          })
      },
      saveRequest() {
        let selected_zones = []

        this.batch_zones.forEach(z => {
          if (z.selected) {
            selected_zones.push(z.value)
          }
        })
        this.packed_zones = selected_zones.join(', ')

        if (!this.modelName) {
          this.modelNameState = false
          return
        }
        let fn = () => {
          this.$http.post('/api/projects/save-clone-request/', {
            model_name: this.modelName,
            workpack_id: this.$store.getters['project/currentProject'].workpack.id,
            aoi: this.aoi,
            username: this.$store.getters['user/user'].username,
            batch_id: this.packed_zones
          }).then(
            res => {
              this.$notify({
                title: 'Info',
                text: 'Model clone request accepted. Please, refer task manager for its status.',
                type: 'info'
              })

              this.$store.getters['cmp/all']['clone']['enabled'] = false
            },
            e => {
              this.$notify({
                title: 'ERROR',
                text: 'Could not register the request',
                type: 'error'
              })
            },
          )
        }

        if (!this.aoi) {
          if (confirm("Please, confirm cloning whole model")) {
            fn()
          }
        } else {
          fn()
        }



      }
    },
    computed: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CloneTool.vue